import React from 'react';
import UserRegistrations from '../users/UserRegistrations';

const SchoolAdminRegistrations = () => (
  <UserRegistrations
    fixedRegistrationType="school_admin"
    title="学校管理员注册审核"
    showTypeFilter={false}
  />
);

export default SchoolAdminRegistrations;
